import React from "react";
import { useAuth } from "./utils/Auth";
import { EmployeeDetail } from "./employees/components/EmployeeDetailLayout";
import { NoActiveEmployee } from "./common/components/NoActiveEmployee";

export const StartPage = () => {
  const { user } = useAuth();

  const employee = user.active_employee;

  if (!employee) {
    return <NoActiveEmployee />;
  }

  return <EmployeeDetail employee_id={employee.id} myPage={true} />;
};
